export default __webpack_public_path__ + "static/media/Medium's Belt of Consumed Souls.ba79637d.jpg";